import React, { useEffect } from "react";
import "./style.scss"
import { useNavigate, useLocation, useSearchParams  } from "react-router-dom";
import { useState } from "react";
import { FaRegHeart } from "react-icons/fa";
import { Button } from "@mui/material";
import Pagination from "@mui/material/Pagination";
import { Formatter } from "utils/formatter";
import { Discount } from "utils/discount";
import { getBookBySearch } from "services/user/bookService";
import { PacmanLoader } from "react-spinners";
const ProductSearch = () => {
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search)
    // const [searchParams] = useSearchParams();
    // const page1 = searchParams.get('page') || 1;
    const type = searchParams.get("type")
    const search = searchParams.get("search")

    const [isLoading, setIsLoading] = useState(false)

    const [totalPage, setTotalPage] = useState(1);

    const book = location.state?.book; // được truyền từ chỗ nhấn xem tất cả

    const navigate = useNavigate();
    // const [page, setPage] = useState(1);
    const [page, setPage] = useState(Number(searchParams.get('page') || 1));

    const [books, setBooks] = useState([])
    const handleChangePage = (event, value) => {
        setPage(value);
        navigate(`/books?search=${search}&page=${value}`);
    };

    useEffect(() => {
        if (type === "hot-book" || type === "best-seller-book" || type === "randomBookByCate") {
            setBooks(book)
        }
        else {
            const fetchBookBySearch = async () => {
                setIsLoading(true)
                try {
                    const response = await getBookBySearch(search, page - 1)
                    if (response && response.data && response.data.content && response.data.page) {
                        setBooks(response.data.content);
                        setTotalPage(response.data.page.totalPages);
                    }
                } 
                catch (error) {
                    console.log("fetchBookBySearch", error)
                }
                finally {
                    setIsLoading(false)
                }
            }
            fetchBookBySearch();
        }
        window.scrollTo(0, 0);
    }, [type, book, search, page])
    return (
        <div className="searchWrapper">
            <div className="container">
                <h2 style={{ color: "#5e2e86" }}>{search ? `Kết quả tìm kiếm: ${search}`: `Kết quả`}</h2>
                <div className="productRow">
                    {/* <div className="item2 productItem2 mb-3">
                        <div className="imgWrapper"
                            onClick={() => navigate(`/search`)}
                        >
                            <img src="https://product.hstatic.net/200000343865/product/4_80d9fdc5eab64df29885417daf6a0c45_94d704766c434cdf8b1074445fcd8ead_large.jpg" alt="{book.title} "className='w-100' loading="lazy"/>
                            <span className="badge bg-danger">- 21%</span>
                            <div className='actions'>
                                <Button
                                    onClick={(e) => { e.stopPropagation();}}>
                                    <FaRegHeart />
                                </Button>
                            </div>
                            <h4>Doraemon Plus Tập 4</h4>
                            <span className='text-success'>In Stock</span>
                            <div className="d-flex justify-content-between">
                                <span className="curPrice text-danger">100000</span>
                                <span className="oriPrice">10000</span>
                            </div>
                        </div>
                    </div> */}
                    {books && Array.isArray(books) && books.length > 0 ? (
                        books.map(book => (
                            <div className="item2 productItem2 mb-3">
                                <div className="imgWrapper"
                                    onClick={() => navigate(`/details/${book.slug}`)}
                                >
                                    <img src={book.imageLink} alt={book.title} className='w-100' loading="lazy"/>
                                        {type ? (
                                            <span className="badge bg-danger">- {Discount(book.originalPrice, book.discountedPrice)}%</span>
                                        ) : (
                                            <span className="badge bg-danger">- {Discount(book.originalPrice, book.discountPrice)}%</span>
                                        )}

                                    <div className='actions'>
                                        <Button
                                            onClick={(e) => { e.stopPropagation();}}>
                                            <FaRegHeart />
                                        </Button>
                                    </div>
                                    <h4>{book.title}</h4>
                                    <span  className={book.availableQuantity > 0 ? 'inStock' : 'outOfStock'}>
                                        {book.availableQuantity > 0 ? 'Còn hàng' : 'Hết hàng'}
                                    </span>
                                    <div className="d-flex justify-content-between mt-1">
                                        {type ? (
                                            <span className="curPrice text-danger">{Formatter(book.discountedPrice)}</span>
                                        ) : (
                                            <span className="curPrice text-danger">{Formatter(book.discountPrice)}</span>
                                        )}
                                        <span className="oriPrice">{Formatter(book.originalPrice)}</span>
                                    </div>
                                </div>
                            </div>
                        ))
                    ) : (
                        <></>
                    )}
                    <div className="pagination d-flex justify-content-center w-100">
                        {type ? (
                            <Pagination
                                count={1}
                                color="secondary"
                                page={1}
                            />
 
                        ) : (
                            <Pagination
                            count={totalPage}
                            color="secondary"
                            page={page}
                            onChange={handleChangePage}
                        />
                        )}
                    </div>
                </div>
            </div>
            {isLoading && (
                <div className="modal">
                    <div className="overlay_loading">
                        <div className="modal-content_loading">
                            <div className="d-flex">
                            <PacmanLoader color="#5e2e86"/>
                            </div>
                        </div>
                    </div>
                </div>
            )} 
        </div>
    )
}

export default ProductSearch;